export default __webpack_public_path__ + "static/media/green-arrow.2329ece4.svg";